export default {
  currentUser(state) {
    return state.currentUser;
  },
};
